import { differenceInCalendarDays, format, isThisYear } from 'date-fns'
import { TeamWithId, UserWithId } from '@innersight-os/shared/firestore-interfaces';

export const formatRelativeDate = (date: Date): string => {
  if(!date) return ''

  const diff = differenceInCalendarDays(date, new Date())

  if (diff < -6 || diff >= 7) {
    return format(date, isThisYear(date) ? 'd MMM' : 'd MMM yyyy')
  } else if (diff < -1) {
    return format(date, "'last' eeee")
  } else if (diff < 0) {
    return 'yesterday'
  } else if (diff < 1) {
    return 'today'
  } else if (diff < 2) {
    return 'tomorrow'
  } else {
    return format(date, "'next' eeee")
  }
}

export const formatRelativeDatetime = (date: Date): string =>
  date ? `${formatRelativeDate(date)}, ${format(date, "h:mmaaaaa'm'")}` : ''

export const namesAndEmailsDropdownListSort = (a: string, b: string) => {
  if (typeof(a) === 'undefined' || typeof(b) === 'undefined') return 1
  if (a.includes("@") && b.includes("@") || !a.includes("@") && !b.includes("@")) return a.localeCompare(b, undefined, {sensitivity: 'base'})
  if (a.includes("@") && !b.includes("@")) return 1
  if (!a.includes("@") && b.includes("@")) return -1
  return 1 // unreachable but required by tsc
}

export const teamNamesAndEmailsDropdownListSort = (a: TeamWithId, b: TeamWithId) => {
  return namesAndEmailsDropdownListSort(a.name, b.name)
}

export const userNamesAndEmailsDropdownListSort = (userA: UserWithId, userB: UserWithId) => {
  return namesAndEmailsDropdownListSort(userA.displayName || userA.email, userB.displayName || userB.email)
}

export const formatVolumeAcquisitionDate = (datestr: string) => {
  if (datestr === 'None') return datestr
  const year = Number(datestr.substr(0,4))
  const month = Number(datestr.substr(4,2))
  const day = Number(datestr.substr(6,2))
  const date = new Date(year, month-1, day) // beware 0 offset for month
  return format(date, 'd MMM yyyy')
}

export const formatVolumeAcquisitionDate2Date = (datestr: string) => {
  if (datestr === 'None') return datestr
  const year = Number(datestr.substr(0,4))
  const month = Number(datestr.substr(4,2))
  const day = Number(datestr.substr(6,2))
  return new Date(year, month-1, day) // beware 0 offset for month
}
